module.exports = __webpack_public_path__ + "static/erp-slider3-c14d26b56f2c5b57d3bd8d8024db8659.jpeg";